import script from "./CajaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CajaForm.vue?vue&type=script&setup=true&lang=js"

import "./CajaForm.vue?vue&type=style&index=0&id=4f4f8af7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f4f8af7"]])

export default __exports__